/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import rightArrowImg from "../assets/images/svg/right-arrow.svg";
import aboutOne from "../assets/images/vatel/a-propos.jpg";
import {useSmoothScrollContext} from "../context/SmoothScrollContext"
const About = () => {
  const { handleLinkClick } = useSmoothScrollContext();
  return (
      <div className="about-area section-padding">


        <div id="why-vatel" className="container">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
            <div>
              <img src={aboutOne} alt="aboutOne" className=" mx-auto"/>
            </div>
            <div>
              <div className="mini-title">Pourquoi choisir Vatel ?</div>
              <h4 className="column-title tw-leading-tight">
                Devenez cadre opérationnel, dirigeant ou entrepreneur en rejoignant une école reconnue <span
                  className="shape-bg">mondialement</span>.
              </h4>
              <div>
                Rejoindre le groupe Vatel c’est faire le choix de la meilleure école hôtelière. Vous êtes assuré de
                préparer un <strong>titre inscrit au RNCP</strong> reconnu par la profession et de profiter de <strong>plus
                de 40 années d'expérience</strong>.
                <br/>
                <br/>
                Le taux d’insertion presque parfait des diplômés Vatel s’explique notamment grâce à :
              </div>
              <ul className=" list-item space-y-6 pt-8 text-base">
                <li className="flex">
                  <div className="flex-none mr-6">
                    <div className="h-16 w-16 rounded-full">
                      <img
                          src={rightArrowImg}
                          alt="lightImg"
                          className=" w-full h-full object-cover rounded-full block"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg mb-1">L’expérience</h4>
                    <div>
                      Accumulée des étudiants tout au long de leur parcours (stage, jeux de rôle, programme
                      d’échange, etc.)
                    </div>
                  </div>
                </li>
                <li className="flex">
                  <div className="flex-none mr-6">
                    <div className="h-16 w-16 rounded-full">
                      <img
                          src={rightArrowImg}
                          alt=""
                          className=" w-full h-full object-cover rounded-full block"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg mb-1">L’alternance</h4>
                    <div>
                      Des semaines de cours théoriques et des semaines d’expérimentation
                    </div>
                  </div>
                </li>
                <li className="flex">
                  <div className="flex-none mr-6">
                    <div className="h-16 w-16 rounded-full">
                      <img
                          src={rightArrowImg}
                          alt=""
                          className=" w-full h-full object-cover rounded-full block"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg mb-1">La pédagogie</h4>
                    <div>
                      Innovante menée par des enseignants qui s'apparentent à de véritables coachs
                    </div>
                  </div>
                </li>
                <li className="flex">
                  <div className="flex-none mr-6">
                    <div className="h-16 w-16 rounded-full">
                      <img
                          src={rightArrowImg}
                          alt=""
                          className=" w-full h-full object-cover rounded-full block"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg mb-1">Un large réseau</h4>
                    <div>
                      De professionnels, impliqués dans la réussite des étudiants
                    </div>
                  </div>
                </li>
              </ul>
              <div className="pt-8">
                <a
                    href="#brochure"
                    onClick={(e) => handleLinkClick(e, 'brochure')}
                    className="btn btn-primary text-center">
                  Télécharger la brochure
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default About;
